import {Formik} from 'formik'
import {useState} from 'react'
import {Link} from 'react-router-dom'
import {CardHeader, Tooltip} from '../../../../modules/components'
import DataTables from '../../../../modules/DataTables'
import parseMoney from '../../../../modules/utils/parseMoney'
import {ButtonSearch} from '../../../../modules/widgets/datatable/ButtonSearch'
import {SearchMaxMoney} from '../../../../modules/widgets/datatable/SearchMaxMoney'
import {SearchMinMoney} from '../../../../modules/widgets/datatable/SearchMinMoney'
import {SearchMonthAt} from '../../../../modules/widgets/datatable/SearchMonthAt'
import {DatatableInvoiceFiltersModel} from './models'
import {PrincipalRoutesEnum} from '../../../../routing/internal/PrincipalRouter'
import {SearchClinic} from '../../../../modules/widgets/datatable/SearchClinic'

export default function DatatableClinicInvoice() {
    const [filters, setFilters] = useState<DatatableInvoiceFiltersModel>()

    const initialFiltersValues = {
        clinic_id: '',
        month_at: '',
        min_money: '',
        max_money: '',
    }

    return (
        <div className='card card-custom'>
            <CardHeader
                title='Faturamento'
                description='Apresenta a lista de faturamentos pendentes'
                goBack={false}
            />
            <div className='card-body'>
                <Formik
                    initialValues={initialFiltersValues}
                    onSubmit={(values) => {
                        setFilters({
                            clinic_id: values.clinic_id,
                            month_at: values.month_at,
                            min_money: values.min_money.substring(2),
                            max_money: values.max_money.substring(2),
                        })
                    }}
                >
                    {(props) => {
                        const {handleChange, handleBlur, handleSubmit} = props
                        return (
                            <form onSubmit={handleSubmit} id='kt_signin_change_password' noValidate>
                                <div className='row'>
                                    <SearchClinic prop={props} col='col-lg-5' />
                                    <SearchMonthAt onChange={handleChange} onBlur={handleBlur} />
                                    <SearchMinMoney onChange={handleChange} onBlur={handleBlur} />
                                    <SearchMaxMoney onChange={handleChange} onBlur={handleBlur} />
                                    <ButtonSearch></ButtonSearch>
                                </div>
                            </form>
                        )
                    }}
                </Formik>
                {!filters?.clinic_id ? (
                    <div className='row mb-5'>
                        <div className='col-lg-12'>
                            <div className='alert alert-warning d-flex align-items-center m-0'>
                                <i className='fas fa-exclamation-triangle fa-3x text-warning me-2'></i>
                                <span className='fw-bold fs-6'>
                                    Selecione o estabelecimento para visualizar as informações
                                </span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <DataTables
                        configs={{
                            head: [
                                'Data',
                                'Qtd. Consultas',
                                'Valor Estabelecimento',
                                'Status',
                                'Ações',
                            ],
                            keys: [
                                'reference_at',
                                'consults_count',
                                'vn_clinic',
                                'status',
                                'actions',
                            ],
                            url: '/core/billing/invoices/clinics/datatable',
                            blockOrder: [
                                'reference_at',
                                'consults_count',
                                'vn_clinic',
                                'status',
                                'actions',
                            ],
                            reverseOrder: true,
                            centeredIndex: [0, 1, 2, 3, 4, 5],
                        }}
                        filters={filters}
                        components={[
                            {
                                target: 2,
                                component: (obj) => (
                                    <span className='fw-bolder'>{parseMoney(obj.vn_clinic)}</span>
                                ),
                            },
                            {
                                target: 3,
                                component: (obj) => (
                                    <span
                                        className={`p-2 rounded badge-light-${
                                            obj.status === 'PAID'
                                                ? 'success'
                                                : obj.status === 'OPENED'
                                                ? 'info'
                                                : 'danger'
                                        }`}
                                    >
                                        {obj.status === 'PAID'
                                            ? 'Pago'
                                            : obj.status === 'OPENED'
                                            ? 'Em aberto'
                                            : 'Pendente'}
                                    </span>
                                ),
                            },
                            {
                                target: 4,
                                component: (obj) => (
                                    <div className='btn-group'>
                                        <Tooltip text='Ver detalhes' placement='top'>
                                            <Link
                                                to={PrincipalRoutesEnum.ShowClinicInvoice.replace(
                                                    ':id',
                                                    obj.id
                                                ).replace(':clinicId', filters.clinic_id)}
                                                className='btn btn-icon btn-light-primary btn-sm'
                                            >
                                                <i className='fas fa-eye' />
                                            </Link>
                                        </Tooltip>
                                    </div>
                                ),
                            },
                        ]}
                    />
                )}
            </div>
        </div>
    )
}
